//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: Make this component smart, so it forces the needed properties in order to avoid conceptual issues
export default {
  name: 'rb-board-with-fields-below',
  props: {
    slidesPerViewDesktop: {
      type: Number,
      default: 3,
    },
    slidesPerViewTablet: {
      type: Number,
      default: 3,
    },
    slidesPerViewMobile: {
      type: Number,
      default: 1,
    },
    columnsOfNextSlide: {
      type: Number,
      default: 5,
    },
    fullScreenMobile: {
      type: Boolean,
      default: true,
    },
  },
  inject: ['overrideSlidesPerView', 'overrideAlwaysShowSwiper', 'overrideColumnsOfNextSlide'],
  computed: {
    columnsOfNextSlideTest() {
      return this.overrideColumnsOfNextSlide ?? this.columnsOfNextSlide
    },
    hasPagination() {
      const comparison = this.slidesPerViewDesktopTest
      return this.$slots?.default?.length > comparison
    },
    slidesPerViewDesktopTest() {
      return this.overrideSlidesPerView ?? this.slidesPerViewDesktop
    },
    alwaysShowSwiper() {
      return this.overrideAlwaysShowSwiper ?? false
    },
  },
}
